import axios from 'axios'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL
// Get the user info
export const fetchUserInfo = async () => {
    try {
        const response = await axios.get(`${apiUrl}/auth/getInfo`, {
            headers: {
                'Content-Type': 'application/json',
            },
            withCredentials: true, // Inclut les cookies dans la requête
        })

        if (!response.data) {
            throw new Error('Erreur lors de la récupération des données.')
        }

        return response.data
    } catch (error) {
        // Gérer l'erreur, par exemple en la retournant ou en l'enregistrant dans un service de logs
        throw error
    }
}

// Get the user info
export const fetchUserPublicInfo = async (userId) => {
    try {
        const response = await axios.get(
            `${apiUrl}/auth/getPublicInfo/${userId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true, // Inclut les cookies dans la requête
            }
        )

        if (!response.data) {
            throw new Error('Erreur lors de la récupération des données.')
        }

        return response.data
    } catch (error) {
        // Gérer l'erreur, par exemple en la retournant ou en l'enregistrant dans un service de logs
        throw error
    }
}

export const logout = async () => {
    try {
        const response = await axios.post(
            `${apiUrl}/auth/logout`,
            {},
            {
                withCredentials: true, // Inclut les cookies dans la requête pour permettre au backend de les effacer
            }
        )

        // Vérifier la réponse pour s'assurer que la déconnexion a réussi
        if (response.status === 200) {
            return response.data.message // Renvoie le message de déconnexion réussie
        } else {
            throw new Error('Échec de la déconnexion.')
        }
    } catch (error) {
        // Gérer l'erreur en cas de problème lors de la déconnexion
        throw error
    }
}
